import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../_services/_user/user.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { LocalService } from '../_services/_storage/local.service';
import { IndexedStorageService } from '../_services/_storage/indexed-db-service.service';
import { SnackbarService } from '../_services/snackbar/snackbar.service';
import { LOCALSTORAGEKEYS } from '../_constants/localStorageKeys';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(
    private http: HttpClient,
    private keycloakService: KeycloakService,
    private localService: LocalService,
    private userService: UserService,
    public indexStorage: IndexedStorageService,
    private router: Router,
    private snack: SnackbarService
    ) {}

    // user password change
    userChangePassword(userId: string, newPassword: string): Observable<any> {
        const url = `${environment.keycloak.issuer}admin/realms/${environment.keycloak.realm}/users/${userId}/reset-password`;
        const payload = {
            type: 'password',
            value: newPassword,
            temporary: false
        };
        return this.http.put(url, payload, { observe: 'body' }).pipe(
            map(() => {
                return { responseMsg: 'Password Successfully Changed' };
            })
        );
    }

    getLoggedinUser() {
        return this.keycloakService.getToken();
    }

    setToken(token: any) {
        const keycloakInstance = this.keycloakService.getKeycloakInstance();
        keycloakInstance.token = token;
    }

    getUserGUID() {
        return this.keycloakService.getKeycloakInstance().tokenParsed?.sub || '';
    }

    getAccessToken() {
        return this.keycloakService.getKeycloakInstance().idTokenParsed;
    }

    getRoles() {
        return this.localService.get(LOCALSTORAGEKEYS.USERROLES);
    }

    logout() {
        this.keycloakService.logout(window.location.origin).then(() => {
            this.snack.successSnackbar('Logged Out SuccessFully');
        });
        localStorage.clear();
        this.localService.clearStorage();
        sessionStorage.clear();
        this.clearCache();

        this.indexStorage.deleteIndexStorage().then((res: any) => {
            if (res) {
                //
            }
        });
    }

    clearCache() {
        this.localService.clearStorage();
        localStorage.clear();
        sessionStorage.clear();
    }
}
